/* eslint-disable no-unused-vars */
import create from 'zustand';

import { getFacetOptionLabelByKey } from './searchHelpers';

const useSearchStore = create((set, get) => ({
    searchFacetsJson: [],
    searchFacetSelections: {},
    searchSortingValue: '',
    setSearchSortingValue: (sortOption) => {
        /**
         * Replace the search sort data
         */
        set((state) => ({ searchSortingValue: sortOption }));
    },
    getSearchFacetDataByKey: (facetKey) => {
        /**
         * Retrieve the Funnelback JSON data for a specific Facet
         *
         * @param {String} facetKey The name of the Facet. e.g. "Resource Type"
         *
         * @returns Array
         */
        const allFacetData = [...get().searchFacetsJson];
        const facetData = [];
        let facetValues = null;

        for (let i = 0, j = allFacetData.length; i < j; ++i) {
            // Find the matching facet data
            if (allFacetData[i].name === facetKey) {
                facetValues = allFacetData[i].allValues;

                // Check if any facet options are available for the provided key
                if (facetValues.length !== 0) {
                    // Parse the options into the required format
                    for (let x = 0, b = facetValues.length; x < b; ++x) {
                        facetData.push({
                            availableItems: facetValues[x].count,
                            label: getFacetOptionLabelByKey(
                                facetValues[x].label
                            ),
                            value: facetValues[x].label,
                        });
                    }
                }
            }
        }

        return facetData;
    },
    setSearchFacetsJson: (facetJson) => {
        /**
         * Replace the search facets JSON data
         */
        set((state) => ({ searchFacetsJson: facetJson }));
    },
    getSearchFacetSelectionsByKey: (facetParamName) => {
        /**
         * Retrieve the selected options for a specific Facet
         *
         * @param {String} facetParamName The queryStringParamName of the Facet. e.g. "f.Resource Type|resourceType"
         *
         * @returns Array
         */
        const allFacetSelections = {
            ...get().searchFacetSelections,
        };
        let facetSelections = [];

        if (allFacetSelections[facetParamName] !== undefined) {
            facetSelections = allFacetSelections[facetParamName];
        }

        return facetSelections;
    },
    setSearchFacetSelectionsByKey: (facetParamName, facetValues) => {
        /**
         * Replace/set the selected options for a specific Facet
         *
         * @param {String} facetParamName The queryStringParamName of the Facet. e.g. "f.Resource Type|resourceType"
         */
        const updatedFacetData = {
            ...get().searchFacetSelections,
        };

        if (facetValues.length === 0) {
            // If there are no values selected, remove the key entirely
            delete updatedFacetData[facetParamName];
        } else {
            // Just replace the existing key in state
            updatedFacetData[facetParamName] = facetValues;
        }

        set((state) => ({ searchFacetSelections: updatedFacetData }));
    },
    setBatchSearchFacetSelectionsByKey: (facetPairs) => {
        /**
         * Replace/set multiple Facets at the same time.
         *
         * @param {Array} facetPairs Array of Object(s), where;
         * queryStringParamName = String. The Facet Key/ID
         * queryStringParamValue = Array. The new value(s)
         */
        const updatedFacetData = {
            ...get().searchFacetSelections,
        };

        for (let i = 0, j = facetPairs.length; i < j; ++i) {
            updatedFacetData[facetPairs[i].queryStringParamName] =
                facetPairs[i].queryStringParamValue;
        }

        set((state) => ({ searchFacetSelections: updatedFacetData }));
    },
    resetSearchFacetSelections: () => {
        /**
         * Clear the search selections data
         */
        set((state) => ({ searchFacetSelections: {} }));
    },
}));

export default useSearchStore;
